<template>
  <button class="card-list-schedule" @click="routerPage">
    <div class="card-list-schedule-status" :class="classStatus">
      {{ textStatus }}
    </div>
    <div class="card-list-schedule-detail">
      <div class="card-list-schedule__div">
        <p class="card-list-schedule__type">Paciente:</p>
        <div class="card-list-schedule__element">
          <div class="card-list-schedule__photo">
            <img
              class="img-fluid"
              :src="schedule.user_photo_url"
              :alt="`foto usuário ${schedule.user_name}`"
              :title="`foto usuário ${schedule.user_name}`"
            />
          </div>
          <div class="card-list-schedule__information">
            <h2 v-if="schedule.user_name" class="card-list-schedule__title">
              {{ schedule.user_name }}
            </h2>
          </div>
        </div>
      </div>
      <div class="card-list-schedule__div">
        <p class="card-list-schedule__type">Profissional:</p>
        <div class="card-list-schedule__element">
          <div class="card-list-schedule__photo">
            <img
              class="img-fluid"
              :src="getPhotoProfile"
              :alt="`foto professional ${schedule.professional_name}`"
              :title="`foto professional ${schedule.professional_name}`"
            />
          </div>
          <div class="card-list-schedule__information">
            <h2
              class="card-list-schedule__title"
              v-if="hasCodeNameOrNameProfessional"
            >
              {{
                schedule?.professional_code_name || schedule?.professional_name
              }}
            </h2>
          </div>
        </div>
      </div>
    </div>
    <div class="card-list-schedule-details">
      <h2 class="card-list-schedule-details__title">Agendamento:</h2>
      <div class="card-list-schedule-details__info">
        <div class="card-list-schedule-details__icon">
          <img
            class="img-fluid"
            src="@/assets/img/time-and-calendar.png"
            alt="icon time and calendar"
            title="icon time and calendar"
          />
        </div>
        <p class="card-list-schedule-details__day">
          Dia e horário:
          <span>{{ schedule.schedule_date_time | dateTimeFormat }}</span>
        </p>
      </div>
      <div class="card-list-schedule-details__info">
        <div class="card-list-schedule-details__icon">
          <svg
            class="card-price__icon"
            width="20"
            height="20"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_1733_968)">
              <path
                d="M6.99984 12.8332C10.2215 12.8332 12.8332 10.2215 12.8332 6.99984C12.8332 3.77817 10.2215 1.1665 6.99984 1.1665C3.77817 1.1665 1.1665 3.77817 1.1665 6.99984C1.1665 10.2215 3.77817 12.8332 6.99984 12.8332Z"
                stroke="black"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M8.75 4.9585C8.35042 4.55892 7.64674 4.28098 7 4.26358M7 4.26358C6.23052 4.24287 5.54167 4.59098 5.54167 5.54184C5.54167 7.29183 8.75 6.41683 8.75 8.16683C8.75 9.16491 7.89612 9.59378 7 9.56158M7 4.26358V3.2085M5.25 8.75016C5.62595 9.25142 6.32497 9.53731 7 9.56158M7 9.56158V10.7918"
                stroke="black"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_1733_968">
                <rect width="14" height="14" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>
        <p class="card-list-schedule-details__price">
          Preço por sessão:
          <span> {{ schedule.price | money }} - {{ getSessionWithText }}</span>
        </p>
      </div>
    </div>
  </button>
</template>

<script>
export default {
  props: {
    schedule: {
      type: Object,
      required: true,
    },
  },
  computed: {
    hasSchedule() {
      return this.schedule && Object.keys(this.schedule).length > 0;
    },
    hasCodeNameOrNameProfessional() {
      return (
        this.hasSchedule &&
        (this.schedule?.professional_code_name ||
          this.schedule?.professional_name)
      );
    },
    getPhotoProfile() {
      return (
        (this.schedule?.profile_photo_file_path ?? this.schedule?.photo_url) ||
        require("@/assets/img/image-user-google.png")
      );
    },
    getSessionWithText() {
      return (
        this.schedule.session +
        (this.schedule.session > 1 ? " sessões" : " sessão")
      );
    },
    isConcluded() {
      return this.schedule.id_status_schedule === 4; // conclúido
    },
    isConfirmed() {
      return this.schedule.id_status_schedule === 3; // confirmado
    },
    isCanceled() {
      return this.schedule.id_status_schedule === 2; // cancelado
    },
    isPending() {
      return this.schedule.id_status_schedule === 1; // pendente
    },
    textStatus() {
      if (this.isConcluded) {
        return "Consulta concluída";
      }

      if (this.isConfirmed) {
        return "Consulta confirmada";
      }

      if (this.isCanceled) {
        return "Consulta cancelada";
      }

      return "Consulta pendente";
    },
    classStatus() {
      if (this.isConcluded) {
        return "card-list-schedule-status--concluded";
      }

      if (this.isConfirmed) {
        return "card-list-schedule-status--confirmed";
      }

      if (this.isCanceled) {
        return "card-list-schedule-status--canceled";
      }

      return "";
    },
  },
  methods: {
    routerPage() {
      this.$router.push({
        name: "ScheduleDetails",
        params: {
          id: this.schedule.id_professional,
          idSchedule: this.schedule.id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.card-list-schedule {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 20px 20px 40px 20px;
  background: var(--white);
  border-radius: 20px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  border: 0;
  &-status {
    position: absolute;
    bottom: 10px;
    right: 20px;
    display: flex;
    align-items: center;
    font-size: 12px;
    font-family: "Font Semibold";
    color: var(--orange);
    padding-left: 15px;
    &::before {
      content: "";
      display: block;
      position: absolute;
      left: 0;
      width: 10px;
      height: 10px;
      background: var(--orange);
      border-radius: 100%;
    }
    &--concluded {
      color: var(--green);
      &::before {
        content: "";
        background: var(--green);
      }
    }
    &--confirmed {
      color: var(--blue);
      &::before {
        content: "";
        background: var(--blue);
      }
    }
    &--canceled {
      color: var(--red-dark);
      &::before {
        content: "";
        background: var(--red-dark);
      }
    }
  }
  &-detail {
    display: flex;
    align-items: flex-start;
    border-bottom: 1px solid var(--gray-1);
    padding-bottom: 10px;
  }
  &__div {
    width: 50%;
    &:first-child {
      padding-right: 20px;
    }
    &:last-child {
      border-left: 1px solid var(--gray-1);
      padding-left: 20px;
    }
  }
  &__type {
    font-size: 14px;
    font-family: "Font Semibold";
    color: var(--black);
    text-align: left;
    margin-bottom: 10px;
  }
  &__element {
    display: flex;
    align-items: center;
    gap: 15px;
  }
  &__photo {
    img {
      border-radius: 100%;
      max-width: 40px;
      max-height: 40px;
      object-fit: cover;
    }
  }
  &__information {
    text-align: left;
  }
  &__title {
    font-size: 12px;
    font-family: "Font Semibold";
    color: var(--black);
    margin-bottom: 0;
  }
  &-details {
    padding: 15px 0;
    text-align: left;
    &__title {
      font-size: 14px;
      font-family: "Font Semibold";
      color: var(--black);
      margin-bottom: 15px;
    }
    &__info {
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 3px 0;
    }
    &__icon {
      img {
        max-width: 20px;
      }
    }
    &__day,
    &__price {
      font-size: 12px;
      font-family: "Font Light";
      color: var(--black);
      margin-bottom: 0;
      span {
        font-size: 14px;
        font-family: "Font Semibold";
      }
    }
  }
}
</style>
